import React from 'react'
import {useHref, useLinkClickHandler} from 'react-router-dom'

const Link = React.forwardRef(({onClick, replace = false, state, target, to, className, ...rest}, ref) => {
  const [hover, setHover] = React.useState(false)

  const toggleHover = () => setHover(!hover)

  let href = useHref(to)
  let handleClick = useLinkClickHandler(to, {
    replace,
    state,
    target,
  })

  return (
    <a
      className={`${hover ? 'tw:text-primary' : ''} ${className}`}
      {...rest}
      href={href}
      onClick={event => {
        onClick?.(event)
        if (!event.defaultPrevented) {
          handleClick(event)
        }
      }}
      ref={ref}
      target={target}
      onMouseEnter={toggleHover}
      onMouseLeave={toggleHover}
    />
  )
})

export default Link
